import { SimpleGrid, Paper, Group, Text, Stack } from "@mantine/core";
import { IconBadge } from "../common/IconBadge";
import { stats } from "../../data/mockData";

const shadow = "0 1px 8px rgba(0,0,0,0.05)";

function StatCard({ stat }) {
  return (
    <Paper
      radius="lg"
      p="xl"
      bg={"#fcfbff"}
      withBorder
      style={{
        borderColor: "#edebeb",
        boxShadow: shadow,
      }}
    >
      <Group gap="md" wrap="nowrap">
        <IconBadge icon={stat.icon} color={stat.color} size={46} />
        <Stack gap={0} style={{ minWidth: 0 }}>
          <Text fw={700} fz="xl" lh={1.1}>
            {stat.value}
          </Text>
          <Text
            fz="sm"
            fw={stat.noteColor ? 500 : 600}
            c={stat.noteColor ? `${stat.noteColor}.6` : "dark.5"}
            truncate
          >
            {stat.note}
          </Text>
        </Stack>
      </Group>
    </Paper>
  );
}

export function StatsRow() {
  return (
    <SimpleGrid cols={{ base: 1, xs: 2, lg: 4 }} spacing="md" mb={32}>
      {stats.map((stat) => (
        <StatCard key={stat.id} stat={stat} />
      ))}
    </SimpleGrid>
  );
}

export default StatsRow;
